/**
 * Разбор поля Equipment.Category на Manufacturer / Model / Serial — прямо на планшете.
 *
 * Во внешней базе Make / Model / SerialNo пустые, реальные данные лежат в Category
 * текстом. Логика — один в один src/Service/EquipmentIdentityParser.php, чтобы
 * офлайн и на сервере получалось одно и то же:
 *
 *   "Hyster * S155 FT, SN: G024V02293N" → Hyster | S155 FT | G024V02293N
 *   "S155XL/ B024D01654K"               →   —    | S155XL  | B024D01654K
 *   "GC70K1. SN:AT89A00628"             →   —    | GC70K1  | AT89A00628
 *   "GPX71500609509FB"                  →   —    |   —     | GPX71500609509FB
 *
 * Производителя по модели не угадываем: что не вытащилось, дописывает человек.
 */

const trimChars = (value, chars) => {
    let start = 0;
    let end = value.length;
    while (start < end && chars.includes(value[start])) start += 1;
    while (end > start && chars.includes(value[end - 1])) end -= 1;
    return value.slice(start, end);
};

const nullIfEmpty = (value) => {
    const trimmed = String(value ?? '').trim();
    return trimmed === '' ? null : trimmed;
};

export function parseEquipmentCategory(rawCategory) {
    const result = { manufacturer: null, model: null, serialNo: null };

    let rest = String(rawCategory ?? '').trim();
    if (rest === '') return result;

    // 1) "Manufacturer * остальное" — единственный надёжный разделитель производителя.
    if (rest.includes('*')) {
        const at = rest.indexOf('*');
        result.manufacturer = nullIfEmpty(rest.slice(0, at));
        rest = rest.slice(at + 1).trim();
    }

    // 2) Явная метка серийника: "SN: xxx", "SN#xxx", "S/N xxx".
    const snPattern = /\bS\s*\/?\s*N\s*[:#.]?\s*(.+)$/i;
    const match = rest.match(snPattern);
    if (match) {
        result.serialNo = nullIfEmpty(trimChars(match[1], ' ,;'));
        rest = trimChars(rest.replace(snPattern, ''), ' ,;');
    }

    // 3) "Model/ Serial" и 4) "Model, Serial" — режем по ПОСЛЕДНЕМУ разделителю.
    if (result.serialNo === null) {
        for (const separator of ['/', ',']) {
            const at = rest.lastIndexOf(separator);
            if (at === -1) continue;
            const left = rest.slice(0, at).trim();
            const right = rest.slice(at + 1).trim();
            if (left !== '' && right !== '') {
                rest = left;
                result.serialNo = right;
                break;
            }
        }
    }

    rest = trimChars(rest, ' ,;:/.');
    if (rest === '') return result;

    // 5) Остаток — модель. Кроме голого серийника без модели и производителя.
    if (result.serialNo === null && result.manufacturer === null && /^[A-Z0-9-]{6,}$/i.test(rest)) {
        result.serialNo = rest;
    } else {
        result.model = rest;
    }

    return result;
}

export default parseEquipmentCategory;
